import { StyleSheet } from "react-native";
const generalStyles = StyleSheet.create({
  textInput: {
    borderColor: "lightgray",
    borderBottomWidth: 1,
    borderStyle: "solid",
    paddingVertical: 5,
  },
  avatarSmall: {
    backgroundColor: "gray",
    height: 32,
    width: 32,
    borderRadius: 16,
  },
});

export default generalStyles;
